// Bócora — scripts propios (vanilla, sin librerías externas)

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initAcordeon();
  initTrustAccordion();
  initGaleria();
  initComparador();
  initContador();
  initVariantes();
  initSlideshow();
  initPaquetes();
});

// Acordeón general (un solo item abierto a la vez)
function initAcordeon() {
  var items = document.querySelectorAll('.boc-acordeon-item');
  items.forEach(function (item) {
    var btn = item.querySelector('[data-boc-acordeon-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('boc-open');
      // Cerrar todos primero
      items.forEach(function (other) {
        other.classList.remove('boc-open');
      });
      // Abrir este si no estaba abierto
      if (!isOpen) {
        item.classList.add('boc-open');
      }
    });
  });
}

// Acordeón de confianza debajo de la foto del héroe (cada uno se abre/cierra por separado)
function initTrustAccordion() {
  var lists = document.querySelectorAll('[data-boc-trust-list]');
  lists.forEach(function (list) {
    var items = list.querySelectorAll('.boc-trust-item');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-boc-trust-q]');
      var panel = item.querySelector('[data-boc-trust-a]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = item.classList.contains('boc-open');
        // Cerrar todos primero
        items.forEach(function(otherItem) {
          otherItem.classList.remove('boc-open');
          var otherPanel = otherItem.querySelector('[data-boc-trust-a]');
          if (otherPanel) {
            otherPanel.style.display = 'none';
          }
        });
        // Abrir el clickeado si no estaba abierto
        if (!isOpen) {
          item.classList.add('boc-open');
          panel.style.display = 'block';
        }
      });
    });
  });
}

// Tarjetas de "elige tu paquete" (varios productos, no variantes)
function initPaquetes() {
  var contenedores = document.querySelectorAll('[data-boc-paquetes]');
  contenedores.forEach(function (contenedor) {
    var tarjetas = contenedor.querySelectorAll('[data-boc-paquete]');
    if (!tarjetas.length) return;
    var wrap = contenedor.closest('.boc-section');
    var boton = wrap ? wrap.querySelector('[data-boc-paquete-comprar]') : null;
    if (!boton) return;

    function seleccionar(tarjeta) {
      tarjetas.forEach(function (t) { t.removeAttribute('data-seleccionado'); });
      tarjeta.setAttribute('data-seleccionado', 'true');
      boton.disabled = false;
    }

    tarjetas.forEach(function (tarjeta) {
      tarjeta.addEventListener('click', function () { seleccionar(tarjeta); });
    });

    var destacada = contenedor.querySelector('.boc-paquete-destacado') || tarjetas[0];
    seleccionar(destacada);

    boton.addEventListener('click', function () {
      var seleccionada = contenedor.querySelector('[data-seleccionado="true"]');
      if (!seleccionada) return;
      var variantId = seleccionada.getAttribute('data-variant-id');
      if (!variantId) return;
      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Agregando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            boton.disabled = false;
            boton.textContent = textoOriginal;
            alert('Ese paquete está agotado por ahora. Prueba con otra opción.');
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        });
    });
  });
}

// Mini-carrusel automático con transición cruzada (simula vídeo sin serlo)
function initSlideshow() {
  var contenedores = document.querySelectorAll('[data-boc-slideshow]');
  if (!contenedores.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  contenedores.forEach(function (cont) {
    var imgs = cont.querySelectorAll('img');
    if (imgs.length < 2 || reduceMotion) return;
    var actual = 0;
    setInterval(function () {
      imgs[actual].classList.remove('boc-slide-active');
      actual = (actual + 1) % imgs.length;
      imgs[actual].classList.add('boc-slide-active');
    }, 4500);
  });
}

// Revelado al hacer scroll (un solo IntersectionObserver compartido)
function initReveal() {
  var items = document.querySelectorAll('.boc-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('boc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('boc-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

// Acordeón de preguntas frecuentes
function initFaq() {
  var items = document.querySelectorAll('.boc-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.boc-faq-q');
    var panel = item.querySelector('.boc-faq-a');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('boc-open');
      items.forEach(function (other) {
        other.classList.remove('boc-open');
        var otherPanel = other.querySelector('.boc-faq-a');
        if (otherPanel) otherPanel.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('boc-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

// Galería de producto: miniatura -> imagen principal
function initGaleria() {
  var galerias = document.querySelectorAll('[data-boc-galeria]');
  galerias.forEach(function (galeria) {
    var main = galeria.querySelector('[data-boc-gal-main]');
    var thumbs = galeria.querySelectorAll('[data-boc-gal-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = full;
          main.alt = alt;
          main.style.opacity = '1';
        }, 120);
        thumbs.forEach(function (t) { t.classList.remove('boc-active'); });
        thumb.classList.add('boc-active');
      });
    });
  });
}

// Comparador antes/después con deslizador
function initComparador() {
  var comparadores = document.querySelectorAll('[data-boc-comparador]');
  comparadores.forEach(function (comp) {
    var handle = comp.querySelector('.boc-comparador-handle');
    var after = comp.querySelector('.boc-comparador-after');
    if (!handle || !after) return;
    var dragging = false;

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('mousedown', function () { dragging = true; });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) {
      if (dragging) mover(e.clientX);
    });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('touchmove', function (e) {
      if (dragging && e.touches[0]) mover(e.touches[0].clientX);
    }, { passive: true });
  });
}

// Cifras animadas (count-up) al entrar en pantalla
function initContador() {
  var contadores = document.querySelectorAll('[data-boc-contador]');
  if (!contadores.length) return;
  if (!('IntersectionObserver' in window)) {
    contadores.forEach(function (el) { el.textContent = el.getAttribute('data-boc-contador'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.getAttribute('data-boc-contador'), 10) || 0;
      var dur = 1400;
      var start = null;
      function paso(ts) {
        if (start === null) start = ts;
        var progreso = Math.min((ts - start) / dur, 1);
        el.textContent = Math.floor(progreso * target).toLocaleString('es-CO');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = target.toLocaleString('es-CO');
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  contadores.forEach(function (el) { observer.observe(el); });
}

// Selector de variantes en la página de producto
function initVariantes() {
  var forms = document.querySelectorAll('[data-boc-producto-form]');
  forms.forEach(function (form) {
    var variantesJson = form.querySelector('[data-boc-variantes-json]');
    if (!variantesJson) return;
    var variantes;
    try {
      variantes = JSON.parse(variantesJson.textContent);
    } catch (e) {
      return;
    }
    var contenedor = form.closest('[data-boc-columna-compra]') || form;
    var pagina = form.closest('.boc-producto-grid') || document;
    var galMain = pagina.querySelector('[data-boc-gal-main]');
    var galThumbs = pagina.querySelectorAll('[data-boc-gal-thumb]');
    var idInput = form.querySelector('input[name="id"]');
    var precioActual = contenedor.querySelector('[data-boc-precio-actual]');
    var precioAntes = contenedor.querySelector('[data-boc-precio-antes]');
    var precioAhorro = contenedor.querySelector('[data-boc-precio-ahorro]');
    var botonSubmit = form.querySelector('[data-boc-add-to-cart]');
    var opcionBtns = form.querySelectorAll('[data-boc-opcion-btn]');

    function opcionesSeleccionadas() {
      var seleccion = {};
      form.querySelectorAll('[data-boc-opcion]').forEach(function (grupo) {
        var activo = grupo.querySelector('.boc-selected');
        if (activo) seleccion[grupo.getAttribute('data-boc-opcion')] = activo.getAttribute('data-valor');
      });
      return seleccion;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var valores = Object.values(seleccion);
      var variante = variantes.find(function (v) {
        return v.options.length === valores.length && v.options.every(function (val, i) { return val === valores[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatoMoneda(variante.price);
      var hayDescuento = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (precioAntes) {
        if (hayDescuento) {
          precioAntes.textContent = formatoMoneda(variante.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      if (precioAhorro) {
        if (hayDescuento) {
          var ahorroPct = Math.round(((variante.compare_at_price - variante.price) * 100) / variante.compare_at_price);
          precioAhorro.textContent = '-' + ahorroPct + '%';
          precioAhorro.style.display = '';
        } else {
          precioAhorro.style.display = 'none';
        }
      }
      if (botonSubmit) {
        botonSubmit.disabled = !variante.available;
        botonSubmit.textContent = variante.available
          ? botonSubmit.getAttribute('data-texto-disponible')
          : botonSubmit.getAttribute('data-texto-agotado');
      }
      if (variante.image && galMain && galMain.src !== variante.image) {
        galMain.src = variante.image;
        galThumbs.forEach(function (thumb) {
          var esElegida = thumb.getAttribute('data-full') === variante.image;
          thumb.classList.toggle('boc-active', esElegida);
        });
      }
    }

    function formatoMoneda(centavos) {
      var valor = centavos / 100;
      return '$' + Math.round(valor).toLocaleString('es-CO');
    }

    opcionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-boc-opcion]');
        grupo.querySelectorAll('[data-boc-opcion-btn]').forEach(function (b) { b.classList.remove('boc-selected'); });
        btn.classList.add('boc-selected');
        actualizar();
      });
    });
  });
}
